// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"84c32c7a99508b2c3368","655":"789eda2684ce4434df78"}[chunkId] + ".js";
};